<div class="inlineCalendarContainer" *ngIf="inlineMode">
	<sat-calendar
		[rangeMode]="rangeMode"
		[minDate]="minDate"
		[maxDate]="maxDate"
		[beginDate]="beginDate"
		[endDate]="endDate"
		[startAt]="startAt"
		#satPicker
		(dateRangesChange)="inlineRangeChange($event)"
	>
	</sat-calendar>
</div>

<div class="popupCalendarContainer" *ngIf="!inlineMode">
	<form [formGroup]="form" class="form-range-selector">
		<button mat-icon-button (click)="navigatePrevious()" *ngIf="enableArrows">
			<mat-icon>keyboard_arrow_left</mat-icon>
		</button>
		<mat-form-field>
			<input
				(click)="satPicker.open()"
				matInput
				placeholder="{{ placeholder }}"
				[satDatepicker]="satPicker"
				formControlName="date"
				(dateChange)="popupRangeChange($event)"
			/>
			<sat-datepicker
				[rangeMode]="rangeMode"
				[beginDate]="beginDate"
				[endDate]="endDate"
				[startAt]="startAt"
				#satPicker
			>
			</sat-datepicker>
			<sat-datepicker-toggle matSuffix [for]="satPicker"></sat-datepicker-toggle>
			<button
				mat-button
				*ngIf="clearInputCross && beginDate != null && endDate != null"
				matSuffix
				mat-icon-button
				aria-label="Clear"
				(click)="clear()"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
		<button mat-icon-button (click)="navigateNext()" *ngIf="enableArrows">
			<mat-icon>keyboard_arrow_right</mat-icon>
		</button>
	</form>
</div>
